import { render, staticRenderFns } from "./turno.vue?vue&type=template&id=21a9a498"
import script from "./turno.vue?vue&type=script&lang=js"
export * from "./turno.vue?vue&type=script&lang=js"
import style0 from "./turno.vue?vue&type=style&index=0&id=21a9a498&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports